import { render, staticRenderFns } from "./Residential_info.vue?vue&type=template&id=ef7b723c"
import script from "./Residential_info.vue?vue&type=script&lang=js"
export * from "./Residential_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports